import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * ModalPortal component - Renders children into a portal at the document body level
 * This ensures modals are rendered outside of any container with potential CSS issues
 */
const ModalPortal = ({ children, isOpen }) => {
  const [portalRoot, setPortalRoot] = useState(null);
  
  useEffect(() => {
    // Check if portal-root exists; if not, create it
    let modalRoot = document.getElementById('portal-root');
    
    if (!modalRoot) {
      modalRoot = document.createElement('div');
      modalRoot.id = 'portal-root';
      document.body.appendChild(modalRoot);
    }
    
    setPortalRoot(modalRoot);
    
    // Cleanup: do not remove the portal root as other modals might be using it
    return () => {};
  }, []);
  
  // Don't render anything if portal root is not ready or modal is not open
  if (!portalRoot || !isOpen) return null;
  
  // Use createPortal to render children into the portal root
  return createPortal(children, portalRoot);
};

export default ModalPortal;
